import { useMemberPaymentApi } from "@apis/useMemberPaymentApi";
import useValidationErrors from "@util/hook/useValidationErrors";
import { isEmpty, isFunction } from "@util/utils";

const buildPostParams = ({ sourceData, formData }) => {
	return {
		memberID: sourceData?.memberID,
		memberPaymentID: sourceData?.memberPaymentID,
		bankCode: formData?.bankCode,
		bankName: formData?.bankName,
		bankAccount: formData?.bankAccount,
		bankAccountName: formData?.bankAccountName,
		bankAccountID: formData?.bankAccountID
	}
}

const useBankAccountSubmitHandle = ({
										formAdapter,
										sourceData,
										refresh
									}) => {

	const { postMemberPaymentBankAccountApi } = useMemberPaymentApi();
	const { validationErrors, updateValidationErrors, clearValidationErrors } = useValidationErrors();

	const checkError = () => {
		clearValidationErrors();
		return formAdapter.validateForm();
	}

	const postMemberPaymentApi = async (params) => {
		const { memberID } = params || {};
		const resp = await postMemberPaymentBankAccountApi(memberID, params);

		if (resp?.isError) {
			// 0002 錯誤
			updateValidationErrors(resp.result);
		} else if (isEmpty(resp)) {
			// 失敗
		} else {
			// 成功
			isFunction(refresh) && refresh();
		}
	}

	const handleSubmit = async () => {
		if (checkError()) return;

		const formData = formAdapter.getFormData();

		await postMemberPaymentApi(buildPostParams({
			sourceData,
			formData,
		}));
	}

	return {
		onSubmit: handleSubmit,
		checkError,
		validationErrors
	}
}

export default useBankAccountSubmitHandle;